// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"6aeda2af","227":"c8b007cb","562":"7db063fb"}[chunkId] + ".chunk.js";
};